var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Locations',{attrs:{"locations":_vm.orderedLocations,"first-location":_vm.firstLocation,"loading":!!_vm.loading},on:{"back":_vm.onBack,"edit":_vm.onEdit,"delete":_vm.onDelete,"order-change":_vm.onOrderChange}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }